import React, { PropsWithChildren } from 'react';
import cx from 'classnames';
import styles from './highlighted-card.module.scss';

export enum HighlightedCardVariants {
  Recommended = 'Recommended',
}

export interface HighlightedCardProps {
  text?: string;
  variant?: HighlightedCardVariants;
}

export const HighlightedCard = ({
  text,
  variant = HighlightedCardVariants.Recommended,
  children,
}: PropsWithChildren<HighlightedCardProps>) => {
  return (
    <div
      className={cx(styles.highlightedItem, {
        [styles.recommended]: variant === HighlightedCardVariants.Recommended,
      })}
    >
      {text && <span>{text}</span>}
      {children}
    </div>
  );
};
